import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Automation } from '../../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AutomationService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  getAutomations(eventId: number) {
    const route = `${this.configUrl}e/a/${eventId}/automations`;
    return this.http.get<Automation[]>(route).pipe();
  }

  upsertAutomation(eventId: number, automation: Automation) {
    const route = `${this.configUrl}e/a/${eventId}/automations`;
    return this.http.post<Automation>(route, automation).pipe();
  }
}
